import { useCallback, useEffect, useState } from 'react';
import { getErrorMessage } from '@/lib/error-message';

export function useFormError(resetKey?: unknown) {
  const [formError, setFormError] = useState<string | null>(null);
  const showFormError = useCallback((error: unknown) => setFormError(getErrorMessage(error)), []);
  const clearFormError = useCallback(() => setFormError(null), []);
  useEffect(() => {
    void resetKey;
    clearFormError();
  }, [resetKey, clearFormError]);
  return { formError, showFormError, clearFormError };
}
